<template>
    <div
        v-if="!isEditMode"
        class="credit-card-form"
    >
        <header
            class="uk-width-1-2@s uk-flex uk-flex-between uk-margin-large-top"
        >
            <h4>Pay by credit card</h4>
            <div
                v-if="isSecure"
                class="uk-margin-right uk-text-right uk-text-success"
            >
                <span>
                    <span uk-icon="lock" /> Secure
                </span>
            </div>
        </header>
        <form-wrapper
            class="uk-form-stacked"
            :validator="$v.buffer"
        >
            <div
                uk-grid
                class="uk-grid-small"
            >
                <div class="uk-width-1-2@s">
                    <text-field
                        v-model="buffer.cardholderName"
                        placeholder="Name on Card"
                        name="cardholderName"
                        label="Name on Card"
                        :hide-label="true"
                        :v="$v.buffer.cardholderName"
                        :show-error-on-blur-only="true"
                        @input="updateInput"
                    />
                </div>
            </div>
            <div
                uk-grid
                class="uk-grid-small"
            >
                <div class="uk-width-1-2@s">
                    <formatted-numeric-field
                        v-model="buffer.cardNumber"
                        placeholder="Card Number"
                        label="Card Number"
                        :hide-label="true"
                        name="cardNumber"
                        :v="$v.buffer.cardNumber"
                        :options="ccFieldOptions"
                        :show-error-on-blur-only="true"
                        @input="updateInput"
                    />
                </div>
            </div>
            <div
                uk-grid
                class="uk-grid-small"
            >
                <div class="uk-width-1-2 uk-width-1-6@s">
                    <numeric-field
                        v-model="buffer.expiryMonth"
                        placeholder="MM"
                        label="Expiry"
                        name="expiryMonth"
                        :v="$v.buffer.expiryMonth"
                        :show-error-on-blur-only="true"
                        @input="updateInput"
                    />
                </div>
                <div class="uk-width-1-2 uk-width-1-6@s">
                    <numeric-field
                        v-model="buffer.expiryYear"
                        placeholder="YY"
                        name="expiryYear"
                        label="Expiry Year"
                        :v="$v.buffer.expiryYear"
                        :show-error-on-blur-only="true"
                        @input="updateInput"
                    />
                </div>
                <div class="uk-width-1-6@s">
                    <numeric-field
                        v-model="buffer.cvn"
                        placeholder=""
                        name="cvn"
                        label="CVN"
                        :v="$v.buffer.cvn"
                        :show-error-on-blur-only="true"
                        @input="updateInput"
                    />
                </div>
            </div>
        </form-wrapper>
    </div>
</template>

<script>

import { integer, required } from "vuelidate/lib/validators";
import { cloneObject } from '@strangeanimals/common-vue-components/src/helpers/helpers';

const NumericField = () => import("@strangeanimals/common-vue-components/src/components/fields/NumericField");
const TextField  = () => import( "@strangeanimals/common-vue-components/src/components/fields/TextField");
const FormattedNumericField  = () => import( "@strangeanimals/common-vue-components/src/components/fields/FormattedNumericField");

export default {
    components: { FormattedNumericField, TextField, NumericField },
    props: {
        mode: {
            type: String,
            default: () => {
                return "create";
            }
        },
        enableValidation: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        cc: {
            type: Object,
            default: () => {
                return {
                    cardNumber: '',
                    expiryMonth: '',
                    expiryYear: '',
                    cvn: '',
                    cardholderName: '',
                };
            }
        }
    },
    data: function () {
        return {
            buffer: cloneObject(this.cc),
            ccFieldOptions: {
                creditCard: true,
                delimiter: "-"
            }
        };
    },
    computed: {
        isEditMode: function () {
            return this.mode === "edit";
        },
        isSecure: function () {
            return document.location.protocol === "https:";
        }
    },
    watch: {
        value: {
            handler() {
                this.buffer = cloneObject(this.cc)
            },
            deep: true
        }
    },
    mounted: function () {
        this.init();
    },
    updated: function () {
        this.init();
    },
    validations() {
        let validateCC = !this.isEditMode;
        return {
            buffer: {
                cardNumber: validateCC ? { required, integer } : {},
                expiryMonth: validateCC ? { required, integer } : {},
                expiryYear: validateCC ? { required, integer } : {},
                cvn: validateCC ? { required, integer } : {},
                cardholderName: validateCC ? { required } : {}
            }
        };
    },
    methods: {
        validateForm() {
            return !this.$v.buffer.$invalid
        },

        updateInput() {
            return this.$emit('change', { cc: this.buffer, isValid: this.validateForm() });
        },

        init() {
            const self = this;
            this.$nextTick(function () {
                self.updateInput();
            })
        }
    },
}
</script>
